import React, { useState } from "react";
import { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import api from "../../api";
import { motion } from "framer-motion";
import { MdOutlineHowToVote } from "react-icons/md";

export const PollsList = ({ userId, setIsPollActive, isPollActive }) => {
  const [polls, setPolls] = useState([]);

  useEffect(() => {
    if (userId) {
      fetchPolls();
    }
  }, [userId]);

  const fetchPolls = async () => {
    const res = await api.getPollsUser();
    // console.log(res);
    if (res.success) {
      setPolls(res.polls);
    }
  };

  return (
    <div className={isPollActive ? "polls-container" : "polls-container my-0"}>
      {polls.map((pollData, index) => (
        <PollModal
          key={pollData.poll._id}
          userId={userId}
          initialData={pollData}
          setIsPollActive={setIsPollActive}
        />
      ))}
    </div>
  );
};

export const PollModal = ({ userId, setIsPollActive, initialData }) => {
  const [poll, setPoll] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [voted, setVoted] = useState(false);
  const [results, setResults] = useState([]);
  const [totalVotes, setTotalVotes] = useState(0);

  // 🔹 Load active poll
  useEffect(() => {
    if (initialData?.poll) {
      setPoll(initialData?.poll);
      setTotalVotes(initialData?.poll?.totalVotes || 0);
      setIsPollActive(true);
      if (initialData?.userVoted) {
        setVoted(true);
        setSelectedOption(initialData?.selectedOptionId);
        setResults(initialData?.results);
      }
    } else {
      setPoll(null);
    }
  }, []);

  // const fetchActivePoll = async () => {
  //   try {
  //     const res = await api.getPollsUser();
  //     console.log(res);

  //     if (res?.success) {
  //       setPoll(res?.poll);
  //       setTotalVotes(res?.poll?.totalVotes || 0);
  //       setIsPollActive(true);
  //       if (res.userVoted) {
  //         setVoted(true);
  //         setSelectedOption(res.selectedOptionId);
  //         setResults(res.results);
  //       } else {
  //       }
  //     } else {
  //       setPoll(null);
  //     }
  //   } catch (err) {
  //     console.error("Error fetching poll:", err);
  //   }
  // };

  // 🔹 Handle vote
  const handleVote = async (optionId) => {
    try {
      setSelectedOption(optionId);
      let payload = {
        pollId: poll._id,
        userId,
        optionId,
      };
      const res = await api.votePoll(payload);

      if (res.success) {
        setVoted(true);
        fetchResults(); // fetch updated results
      } else {
        alert(res.message);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // 🔹 Fetch poll results
  const fetchResults = async () => {
    try {
      const res = await api.pollResult({ pollId: poll._id });
      // console.log(res);

      if (res.success) {
        setResults(res.results);
        setSelectedOption(res.selectedOptionId);
        setTotalVotes(res?.totalVotes || 0);
      }
    } catch (err) {
      console.error("Error fetching results:", err);
    }
  };

  return (
    <>
      {poll?.title && (
        <div className="pollMain">
          <h5 className="title">Vote & Share Your Opinion</h5>
          <div className="content">
            <h6 className="">{poll?.title}</h6>

            {!voted ? (
              <div className="space-y-3">
                {poll?.options.map((option) => (
                  <button
                    key={option._id}
                    onClick={() => handleVote(option._id)}
                    className={`mb-2 plrow w-100
              ${selectedOption === option._id ? "selected" : ""}`}
                  >
                    <span className="text">{option.text}</span>
                  </button>
                ))}
              </div>
            ) : (
              <div className="d-flex flex-column gap-2 mt-2">
                {results.map((opt, index) => {
                  const maxPercentage = Math.max(
                    ...results.map((r) => r.percentage),
                  );
                  const isHighest = opt.percentage === maxPercentage;

                  return (
                    <div key={index} className="position-relative mb-2">
                      {/* ✅ Animated background bar */}
                      <motion.div
                        initial={{ width: 0 }}
                        animate={{ width: `${opt.percentage}%` }}
                        transition={{ duration: 0.8 }}
                        className={`position-absolute top-0 start-0 h-100 rounded `}
                      />

                      {/* ✅ Main content */}
                      <div
                        className={`plrow ${
                          opt.text ===
                          poll.options.find((o) => o._id === selectedOption)
                            ?.text
                            ? "selected"
                            : ""
                        }`}
                      >
                        <div
                          className={
                            isHighest ? "backgroundC green" : "backgroundC red"
                          }
                          style={{ width: `${opt.percentage}%` }}
                        ></div>
                        <span className="text">{opt.text}</span>
                        <span className="small fw-semibold perc">
                          {opt.percentage}%
                        </span>
                      </div>
                    </div>
                  );
                })}

                <p className="voteCount">
                  <span>
                    <MdOutlineHowToVote fontSize={20} />
                  </span>{" "}
                  {totalVotes} votes
                </p>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};
